const getTransitionTextDuration = (props) => {
    const { length, maxDuration = 4, cps = 400 } = props;
    // The time it will take to add/remove a character per frame multiplied by
    // the total characters length.
    const realDuration = ((1000 / cps) * length) / 1000;
    return Math.min(realDuration, maxDuration);
};
export { getTransitionTextDuration };
